<script>
import { mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateSetup from '../customer/list/setup';
import Transaction from '../customer/list/transaction';
import TechDetay from '../customer/modals/tech_detail';
import KurulumModal from '../customer/modals/kurulum_modal';
import MacModal from '../customer/modals/mac_modal';
import VericiTransaction from './verici_transaction.vue';
import Loader from "@/components/widgets/loader.vue";
import datatableMixin from '@/helpers/mixins/datatableMixin';
import Datatable from '@/components/Datatable';
import SearchableSelect from '@/components/SearchableSelect';
import { notify } from '@/helpers/notify';

export default {
  page: {
    title: "İş Listesi",
  },
  mixins: [datatableMixin],
  components: {
    Layout,
    PageHeader,
    CreateSetup,
    Transaction,
    TechDetay,
    KurulumModal,
    MacModal,
    Loader,
    VericiTransaction,
    Datatable,
    SearchableSelect
  },
  computed: {
    ...mapGetters('authfack', ['userdata']),
    isTech() {
      return this.userdata.currentUser.role_name === 'tech';
    }
  },
  data() {
    return {
      title: "İŞ LİSTESİ",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "İŞ LİSTESİ", active: true },
      ],
      endpoint: 'technic-service',
      disableAutoLoad: true,
      techDetail: {},
      dataLoading: true,
      personelList: [],
      ilceList: [],
      userList: [],
      kurulumDetay: {},
      kurulumModalOpen: 0,
      openTab: 0,
      vericiData: {},
      vericiDataModal: 0,
      form: {
        appointment_at: '',
        user_id: null,
        quarter_id: null,
        assigned_userid: null
      },
      buttons: [
        { title: "İşleme Al", icon: 'check', func: this.islemeAl, visible: [1, 2, 3, 4] },
        { title: "Arıza Detay", icon: 'check', func: this.arizaDetay, visible: [3] },
        { title: "İşleme Al", icon: 'check', func: this.islemeAl, visible: [5] },
        { title: "Hata Detay", icon: 'check', func: this.arizaDetay, visible: [5] },
      ],
      columns: [
        { name: '', key: 'action', orderable: false },
        { name: 'Tip', key: 'type_id', orderable: false, width: 120 },
        { name: 'Kullanıcı Adı', key: 'username', orderable: true, width: 140 },
        { name: 'Randevu Tarihi', key: 'appointment_at', className: 'text-end', orderable: true, width: 150 },
        { name: 'Randevuyu Açan', key: 'user_name', orderable: false, width: 130 },
        { name: 'İsim Soyisim', key: 'fullname', orderable: true, width: 150 },
        { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', orderable: false, width: 130 },
        { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', orderable: false, width: 130 },
        { name: 'İl', key: 'district_name', className: 'text-end', width: 120 },
        { name: 'Bölge', key: 'quarter_name', className: 'text-end', width: 120 },
        { name: 'Adres', key: 'address', className: 'text-end', orderable: false },
      ],
      
      tableData: {
        detail: true,
        detailOpen: false,
        excel: true,
        searchable: {    
           visible:true,
          placeholder:"İsim Soyisim Ara"
        }
      },
      exportName: 'IS_LISTESI',
      update: 0,
      data: {},
      transactionData: {},
      rows: [],
      macModalOpen: 1,
      vericiDatas: []
    };
  },
  mounted() {
    this.getIlce().then(e => { this.ilceList = e; });
    this.getUserList().then(e => { this.userList = e; });
    this.today();
    this.searchParams = { ...this.form };

    if (this.userdata.currentUser.role_name === 'admin' || this.userdata.currentUser.role_name === 'personel') {
      this.getUsers().then(data => {
        const personelList = data.map(e => ({ id: e.id, name: e.name }));
        this.personelList = personelList;
        this.columns.push({ name: 'Atanan', key: 'assigned_name', orderable: false, width: 130 });
      });
      this.buttons.push({ title: "Düzenle", icon: 'edit', func: this.edit, visible: [1, 2, 3, 4] });
      this.buttons.push({ title: "Sil", icon: 'trash', func: this.sil, visible: [1, 2, 3, 4] });
      this.loadPage();
    }

    if (this.isTech) {
      this.loadTechItems();
    }
  },
  methods: {
    buildPayload() {
      return {
        columnFilters: { ...this.searchParams },
        sort: this.sort.column
          ? [{ field: this.sort.column, type: this.sort.order || 'asc' }]
          : [{ field: '', type: '' }],
        page: this.params.page,
        perPage: this.params.per_page,
      };
    },

    async loadPage() {
      this.params.page === 1 ? this.isLoading = true : this.pageLoading = true;

      try {
        const response = await this.$http.post(this.endpoint, this.buildPayload());
        this.tableData.data = response.data.data;
        this.tableData.pagination = {
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          total: response.data.total,
        };
      } finally {
        this.params.page === 1 ? this.isLoading = false : this.pageLoading = false;
      }
    },

    handleSortColumn(columnKey, sortOrder) {
      if (this.isLoading) return;
      this.sort.column = columnKey;
      this.sort.order = sortOrder;
      this.params.page = 1;
      this.loadPage();
    },

    handleFilterChange() {
      this.searchParams = { ...this.form };
      this.params.page = 1;
      if (this.isTech) {
        this.loadTechItems();
      } else {
        this.loadPage();
      }
    },

    dateFormat(date) {
      const d = date instanceof Date ? date : new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    today() {
      this.form.appointment_at = this.dateFormat(new Date());
    },

    setToday() {
      this.today();
      this.handleFilterChange();
    },

    setTomorrow() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.form.appointment_at = this.dateFormat(tomorrow);
      this.handleFilterChange();
    },

    setNextDay() {
      const next = new Date();
      next.setDate(next.getDate() + 2);
      this.form.appointment_at = this.dateFormat(next);
      this.handleFilterChange();
    },

    clearAppointment() {
      this.form.appointment_at = '';
      this.handleFilterChange();
    },

    clearFilter(field) {
      this.form[field] = null;
      this.handleFilterChange();
    },

    vericiLoadItems() {
      const appointmentAt = this.form.appointment_at || new Date().toISOString().slice(0, 10);
      this.$http.post(`/transmitter/faults?is_listesi=true&appointment_at=${appointmentAt}`)
        .then(response => { this.vericiDatas = response.data.data || []; });
    },

    loadTechItems() {
      this.dataLoading = true;
      this.$http.post(this.endpoint, {
        columnFilters: { ...this.form },
        sort: [{ field: '', type: '' }],
        page: 1,
        perPage: 50,
      }).then(res => {
        // Verici kayıtları ayrı accordion'da gösterilir
        this.rows = (res.data.data || []).filter(row => !row.transmitter_id);
        this.dataLoading = false;
      });
      this.vericiLoadItems();
    },

    type(row, message = '') {
      let type = typeof row === 'object' ? (row.type_id || row.type) : row;
      type = Number(type);
      const verici = row.transmitter_id ? 'Verici ' : '';
      let out = '';
      switch (type) {
        case 1:
          out = `<label style="font-size:0.8rem;margin:0" class="badge bg-success">${verici}${message}Kurulum</label>`;
          break;
        case 2:
          out = `<label style="font-size:0.8rem;margin:0" class="badge bg-danger">${verici}${message}Söküm</label>`;
          break;
        case 3:
          out = `<label style="font-size:0.8rem;margin:0" class="badge bg-warning">${verici}${message}Arıza</label>`;
          break;
        case 4:
          out = `<label style="font-size:0.8rem;margin:0" class="badge bg-info">${message}Taşıma</label>`;
          break;
        case 5:
          out = `<label style="font-size:0.8rem;margin:0" class="badge bg-secondary">Hata Kaydı</label>`;
          break;
      }
      return out;
    },

    typeBadge(row) {
      const verici = row.transmitter_id ? 'Verici ' : '';
      switch (Number(row.type_id || row.type)) {
        case 1: return { class: 'bg-success', text: `${verici}Kurulum` };
        case 2: return { class: 'bg-danger', text: `${verici}Söküm` };
        case 3: return { class: 'bg-warning', text: `${verici}Arıza` };
        case 4: return { class: 'bg-info', text: 'Taşıma' };
        case 5: return { class: 'bg-secondary', text: 'Hata Kaydı' };
        default: return { class: 'bg-secondary', text: '-' };
      }
    },

    async getUsers() {
      return await this.$http.get('/technic-service/listServicePersonel')
        .then(response => response.data.content);
    },

    async getIlce() {
      return await this.$http.post('/address/ilce')
        .then(response => response.data);
    },

    async getUserList() {
      return await this.$http.post('/users?output=one&fields=id,name')
        .then(response => response.data);
    },

    appointment(row) {
      return this.formatDate(row.appointment_at, 'DD.MM.YYYY HH') + ':00';
    },

    formatExpiredate(obj) {
      const hedefTarih = new Date(obj);
      const simdi = new Date();
      const farkMs = hedefTarih - simdi;
      const kalanGun = Math.ceil(farkMs / (1000 * 60 * 60 * 24));
      return kalanGun < 0 ? '-' : kalanGun;
    },

    edit(props) {
      this.data = {
        id: props.id,
        assigned_userid: props.assigned_userid,
        appointment_at: props.appointment_at,
        content: props.content,
        type: props.type_id,
        group: props.technic_group_id,
      };
      this.update = this.update + 1;
      this.$parent.$bvModal.show('setup');
    },

    arizaDetay(props) {
      this.techDetail = props;
      this.$parent.$bvModal.show('tech_detail');
    },

    islemeAl(props) {
      if (props.transmitter_id) {
        this.vericiIslem({ id: props.id, transmitter_id: props.transmitter_id });
        return;
      }
      const { id, subscription_id, username, password, static_ip, type_id, mac, fullname, tariff_name, tariff_price, cp_pass } = props;
      this.transactionData = { subs_id: subscription_id, id, username, password, static_ip, type_id, mac, fullname, tariff_name, tariff_price, cp_pass };
      this.$parent.$bvModal.show('transaction');
    },

    buttonVisible(button, row) {
      if (!button.visible.includes(row.type_id)) return false;
      if (row.transmitter_id && button.title !== 'İşleme Al') return false;
      if (row.assigned_userid && button.title === 'Personele Ata') return false;
      return true;
    },

    sil(props) {
      this.$swal({
        title: "Silinecek?",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil"
      }).then((result) => {
        if (result.value) {
          this.$http.delete('/technic-service/' + props.id)
            .then(response => {
              if (response.data.code == 100) {
                notify.success(response.data.message);
                this.isTech ? this.loadTechItems() : this.loadPage();
                return;
              }
              notify.error(response.data.message);
            });
        }
      });
    },

    konumGetir(props) {
      const googleMapsUrl = `https://www.google.com/maps?q=${props.coordinate}`;
      window.open(googleMapsUrl, '_blank');
    },

    kurulumResimleri(props) {
      this.kurulumDetay = { id: props.subscription_id, action: 'read', resim: true };
      this.kurulumModalOpen = Math.floor(Math.random() * 1000);
      this.$parent.$bvModal.show('kurulum_modal');
    },

    mac() {
      this.macModalOpen = this.macModalOpen + 1;
      this.$parent.$bvModal.show('mac_modal');
    },

    vericiIslem(props) {
      this.vericiData = props;
      this.vericiDataModal += 1;
      this.$parent.$bvModal.show('verici_transaction');
    },

    excelExport() {
      const currentDate = new Date();
      const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_${this.exportName}.xlsx`;

      this.$http.post('/technic-service?excel=true', this.buildPayload(), { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('Excel dosyası indirilirken bir hata oluştu:', error);
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <VericiTransaction
      :data="vericiData"
      :openModal="vericiDataModal"
      @loadItems="vericiLoadItems"
    />

    <CreateSetup
      :update="update"
      :id="data.id"
      :assigned_userid="data.assigned_userid"
      :appointment_at="data.appointment_at"
      :group="data.group"
      :content="data.content"
      :type="data.type"
      @loadItems="isTech ? loadTechItems() : loadPage()"
    />

    <KurulumModal :data="kurulumDetay" :modelOpen="kurulumModalOpen" />

    <Transaction
      :transactionData="transactionData"
      @loadItems="isTech ? loadTechItems() : loadPage()"
    />

    <TechDetay :data="techDetail" />

    <MacModal :modelOpen="macModalOpen" />

    <Loader :loading="true" :load="dataLoading" v-if="isTech">
      <div class="row mb-3">
        <div class="col-md-12">
          <button class="btn btn-outline-info" @click="mac()">M.A.C. Adresi Sorgula</button>
        </div>
      </div>
      <div class="row mb-3" v-if="rows.length == 0 && vericiDatas.length == 0">
        <div class="col-md-12">
          <div class="alert bg-light" style="border-left:solid 3px red">İş Emri Bulunmamaktadır.</div>
        </div>
      </div>
      <div class="row mb-3" v-for="(row, i) in vericiDatas" :key="`verici${i}`">
        <div class="col-md-12" @click="openTab = i">
          <div class="accordion" :id="`accordionVerici${i}`">
            <div class="accordion-item">
              <h2 class="accordion-header" :id="`headingVerici${i}`">
                <button class="accordion-button" style="padding: 10px 20px;" :class="{ collapsed: openTab != i }" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapseVerici${i}`" aria-expanded="true" :aria-controls="`collapseVerici${i}`" v-html="type(row)"></button>
              </h2>
              <div class="accordion-body">
                <div class="row" v-if="row.apartment_id">
                  <div class="col-md-12"><strong>Apartman Sistemi Var</strong></div>
                </div>
                <div class="row"><div class="col-md-12">Verici: <strong>{{ row.transmitter_name }}</strong></div></div>
                <div class="row"><div class="col-md-12">Pop Noktası: <strong>{{ row.transmitter_group_name }}</strong></div></div>
                <div class="row"><div class="col-md-12">Bölge: <strong>{{ row.district_name }}</strong></div></div>
                <div class="row"><div class="col-md-12">MAC: <strong>{{ row.mac }}</strong></div></div>
              </div>
              <div :id="`collapseVerici${i}`" class="accordion-collapse collapse" :class="{ show: openTab == i }" :aria-labelledby="`headingVerici${i}`">
                <div class="accordion-body">
                  <div class="row">
                    <div class="d-grid">
                      <button class="btn btn-block btn-outline-success" @click="vericiIslem(row)">İşleme Al</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3" v-for="(row, i) in rows" :key="i">
        <div class="col-md-12" @click="openTab = i">
          <div class="accordion" :id="`accordionExample${i}`">
            <div class="accordion-item">
              <h2 class="accordion-header" :id="`heading${i}`">
                <button class="accordion-button" style="padding: 10px 20px;" :class="{ collapsed: openTab != i }" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapseOne${i}`" aria-expanded="true" :aria-controls="`collapseOne${i}`" v-html="type(row)"></button>
              </h2>
              <div class="accordion-body">
                <div class="row" v-if="row.type_id == 3">
                  <div class="col-md-12">Tanım: <strong>{{ row.subject }}</strong></div>
                </div>
                <div class="row" v-if="row.type_id == 3">
                  <div class="col-md-12">Açıklama: <strong>{{ row.content }}</strong></div>
                </div>
                <div class="row"><div class="col-md-12">İsim Soyisim: <strong>{{ row.fullname }}</strong></div></div>
                <div class="row"><div class="col-md-12">Telefon: <strong>{{ row.phonenumber }}</strong></div></div>
                <div class="row">
                  <div class="col-md-12">
                    Adres: <strong>{{ row.address }}</strong> <strong>{{ row.district_name }} / {{ row.quarter_name }}</strong>
                  </div>
                </div>
                <div class="row"><div class="col-md-12">Not: <strong>{{ row.content }}</strong></div></div>
                <div class="row" v-if="row.type_id == 3">
                  <div class="col-md-12">Kalan Gün: <strong>{{ formatExpiredate(row.expiredate) }}</strong></div>
                </div>
                <div class="row" v-if="row.type_id == 5">
                  <div class="col-md-12">
                    Yeni Kurulacak Adres: <strong>{{ row.newaddress }}</strong> <strong>{{ row.newdistrict_name }} / {{ row.newquarter_name }}</strong>
                  </div>
                </div>
              </div>
              <div :id="`collapseOne${i}`" class="accordion-collapse collapse" :class="{ show: openTab == i }" :aria-labelledby="`heading${i}`">
                <div class="accordion-body">
                  <div class="row mb-2" v-if="row.type_id != 1">
                    <div class="d-grid">
                      <button class="btn btn-block btn-outline-primary" @click="konumGetir(row)">Konumu Görüntüle</button>
                    </div>
                  </div>
                  <div class="row mb-2" v-if="row.type_id != 1">
                    <div class="d-grid">
                      <button class="btn btn-block btn-outline-info" @click="kurulumResimleri(row)">Kurulum Resimleri Görüntüle</button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="d-grid">
                      <button class="btn btn-block btn-outline-success" @click="islemeAl(row)">İşleme Al</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>

    <div class="row" v-else>
      <div class="col-12">
        <Datatable
          :columns="columns"
          :tableData="tableData"
          tableDataLoad="pagination"
          @search-query="reLoadPage"
          @sort-column="handleSortColumn"
          @page-change="pageChange"
          @excel-export="excelExport"
          :loading="isLoading"
          :poading="pageLoading"
        >
          <template #searchItems>
            <div class="col-lg-12 mt-3">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      Randevu Tarihi
                      <span
                        v-if="form.appointment_at"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearAppointment"
                      >temizle</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="date"
                        class="form-control"
                        v-model="form.appointment_at"
                        @change="handleFilterChange"
                      >
                    </div>
                    <div class="d-flex flex-wrap gap-2 mt-2">
                      <button class="btn btn-sm btn-outline-secondary" type="button" @click="setToday">Bugün</button>
                      <button class="btn btn-sm btn-outline-secondary" type="button" @click="setTomorrow">Yarın</button>
                      <button class="btn btn-sm btn-outline-secondary" type="button" @click="setNextDay">Sonraki Gün</button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      Randevuyu Oluşturan
                      <span
                        v-if="form.user_id"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearFilter('user_id')"
                      >temizle</span>
                    </label>
                    <SearchableSelect
                      v-model="form.user_id"
                      :options="userList"
                      label="name"
                      :reduceFn="o => o.id"
                      placeholder="Personel ara..."
                      searchable
                      @input="handleFilterChange"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      Bölge
                      <span
                        v-if="form.quarter_id"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearFilter('quarter_id')"
                      >temizle</span>
                    </label>
                    <SearchableSelect
                      v-model="form.quarter_id"
                      :options="ilceList"
                      label="name"
                      :reduceFn="o => o.id"
                      placeholder="Bölge ara..."
                      searchable
                      @input="handleFilterChange"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      Atanan
                      <span
                        v-if="form.assigned_userid"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearFilter('assigned_userid')"
                      >temizle</span>
                    </label>
                    <SearchableSelect
                      v-model="form.assigned_userid"
                      :options="personelList"
                      label="name"
                      :reduceFn="o => o.id"
                      placeholder="Atanan personel ara..."
                      searchable
                      @input="handleFilterChange"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template #type_id="{ row }">
            <span class="badge font-size-12" :class="typeBadge(row).class">{{ typeBadge(row).text }}</span>
          </template>

          <template #appointment_at="{ row }">
            {{ appointment(row) }}
          </template>

          <template #address="{ row }">
            <span v-b-popover.hover.auto="row.address">{{ row.address }}</span>
          </template>

          <template #phonenumber="{ row }">
            <a :href="`tel:${row.phonenumber}`">{{ row.phonenumber }}</a>
          </template>

          <template #phonenumber2="{ row }">
            <a target="_blank" :href="`https://wa.me/${row.phonenumber2 || row.phonenumber}`">
              {{ row.phonenumber2 || row.phonenumber || '-' }}
            </a>
          </template>

          <template #action="{ row }">
            <b-dropdown
              toggle-class="font-size-16 p-0"
              toggle-tag="a"
              variant="white"
              append-to-body
            >
              <template #button-content>
                <i class="mdi mdi-dots-horizontal"></i>
              </template>
              <template v-for="(button, i) in buttons">
                <b-dropdown-item
                  :key="i"
                  v-if="buttonVisible(button, row)"
                  @click="button.func(row)"
                >
                  <i class="bx" :class="`bx-${button.icon}`"></i> {{ button.title }}
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>
